<template>
  <div id="pagecontent">
    <div id="down_mask" v-if="showDownMask" @click="showDownMask=true;">
      <p>Please click top right conner
        <img src="static/img/shenglue.png" />
        Select open in browser, then download our App
      </p>
      <img src="static/img/downapp_jt.png" />
    </div>
    <van-notice-bar :left-icon="require('../assets/img/laba.png')" :scrollable="false" class="sendCardAd" background="rgba(74, 0, 98,.7)" color="#fff" v-if="friendSendCard&&friendSendCard.length>0">
      <van-swipe
        vertical
        class="sendCardswiper"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item v-for="(item,index) in friendSendCard" :key="'item'+index">
          <div class="fc-elip-1">{{item | friendSendCardInfo(te)}}</div>
        </van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <div class="fc-relative">
      <img class="banner1" :src="require('../assets/img/' + thisLang + '/banner_01.png')" />
      <div class="baomingbtn">
        <img :src="require('../assets/img/' + thisLang + '/baoming2.png')" v-if="myinfo.cs.s" />
        <img class="animateClass" :src="require('../assets/img/' + thisLang + '/baoming.png')" @click="baoming()" v-else />
      </div>
      <img src="../assets/img/active_time.png" class="activeTime">
      <img :src="require('../assets/img/' + thisLang + '/banner_02.png')" width="100%" style="margin-top:-0.02rem;" />
    </div>

    <div class="content">
      <div class="progressbox bg_gradient">
        <p class="progressbox_title">{{$t('m.draws_diamonds_num')}}</p>
        <div class="progressbarbox">
          <span class="fcfont startnum">0</span>
          <div class="progressbar">
            <div class="fc-relative">
              <div class="jindu" :style="{'left':progressNum(myinfo.cs.ctp)}">
                <img class="dot" src="../assets/img/progress.png" />
                <p class="mufa fcfont">{{myinfo.cs.ctp|rechargeAmount}}</p>
              </div>
            </div>
          </div>
          <span class="fcfont endnum">500,000</span>
        </div>
      </div>

      <div class="drawInfo">
        <div class="drawInfo_text">
          {{$t('m.available_draws')}}: <span class="color_yellow">{{myinfo.cs.c}}</span>
        </div>
        <div class="fc-space-between">
          <img class="choubtn" :src="require('../assets/img/' + thisLang + '/btn_1_1.png')" @click="choujiang(1)" v-if="myinfo.cs.c>=1&&activeStute==1" />
          <img class="choubtn" :src="require('../assets/img/' + thisLang + '/btn_1_2.png')" v-else />

          <img class="choubtn" :src="require('../assets/img/' + thisLang + '/btn_9_1.png')" @click="choujiang(9)" v-if="myinfo.cs.c>=9&&activeStute==1" />
          <img class="choubtn" :src="require('../assets/img/' + thisLang + '/btn_9_2.png')" v-else />
          <img class="choubtn" :src="require('../assets/img/' + thisLang + '/btn_99_1.png')" @click="choujiang(99)" v-if="myinfo.cs.c>=99&&activeStute==1" />
          <img class="choubtn" :src="require('../assets/img/' + thisLang + '/btn_99_2.png')" v-else />

        </div>
      </div>
      <div class="bg_gradient myCard">
        <p class="drawInfo_text">{{$t('m.click_send_friend')}}</p>
        <div class="card_group fc-flex-center">
          <div class="cardbox" :class="{'on':selCard==1}" @click="clickCard(1,myinfo.c.njc)">
            <img class="cardimg" :src="myinfo.c.njc>0?require('../assets/img/' + thisLang + '/card_1_2.png'):require('../assets/img/' + thisLang + '/card_1_1.png')"/>
            <span class="flag" v-if="myinfo.c.njc>0">{{myinfo.c.njc}}</span>
          </div>
          <div class="cardbox" :class="{'on':selCard==2}" @click="clickCard(2,myinfo.c.zjc)">
            <img class="cardimg" :src="myinfo.c.zjc>0?require('../assets/img/' + thisLang + '/card_2_2.png'):require('../assets/img/' + thisLang + '/card_2_1.png')"/>
            <span class="flag" v-if="myinfo.c.zjc>0">{{myinfo.c.zjc}}</span>
          </div>
          <div class="cardbox" :class="{'on':selCard==3}" @click="clickCard(3,myinfo.c.bjc)">
            <img class="cardimg" :src="myinfo.c.bjc>0?require('../assets/img/' + thisLang + '/card_3_2.png'):require('../assets/img/' + thisLang + '/card_3_1.png')"/>
            <span class="flag" v-if="myinfo.c.bjc>0">{{myinfo.c.bjc}}</span>
          </div>
          <div class="cardbox" :class="{'on':selCard==4}" @click="clickCard(4,myinfo.c.hjc)">
            <img class="cardimg" :src="myinfo.c.hjc>0?require('../assets/img/' + thisLang + '/card_4_2.png'):require('../assets/img/' + thisLang + '/card_4_1.png')"/>
            <span class="flag" v-if="myinfo.c.hjc>0">{{myinfo.c.hjc}}</span>
          </div>
          <div class="cardbox" :class="{'on':selCard==5}" @click="clickCard(5,myinfo.c.gjc)">
            <img class="cardimg" :src="myinfo.c.gjc>0?require('../assets/img/' + thisLang + '/card_5_2.png'):require('../assets/img/' + thisLang + '/card_5_1.png')"/>
            <span class="flag" v-if="myinfo.c.gjc>0">{{myinfo.c.gjc}}</span>
          </div>
        </div>

        <div class="giftid_input">
          <div class="inputbox"><input type="number" v-model="sendFriendId" placeholder="BuzzCast ID to send?" @input="userIdInput()" /></div>
          <!-- <img :src="require('../assets/img/'+thisLang+'/btn_gift_1.png')"> -->
          <img :src="require('../assets/img/' + thisLang + '/btn_gift_2.png')" @click="sendCard" v-if="sendFriendId&&activeStute==1" />
          <img :src="require('../assets/img/' + thisLang + '/btn_gift_1.png')" v-else />
        </div>
      </div>
      <div class="hecheng">
        <van-notice-bar class="hc_notice" :scrollable="false" background="#4d0072" color="#fff" v-if="kingTong&&kingTong.length>0">
          <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false" >
            <van-swipe-item v-for="(item,index) in kingTong" :key="'item'+index">
              <div class="fc-elip-1 itembar">
                {{$t('m.gongxi_tip',{'msg_ss':item})}}
              </div>
            </van-swipe-item>
          </van-swipe>
        </van-notice-bar>

        <div class="cardbox_big">
          <img class="cardimg" :src="myinfo.wc>0?require('../assets/img/' + thisLang + '/king_card_2.png'):require('../assets/img/' + thisLang + '/king_card_1.png')" />
          <span class="flag" v-if="myinfo.wc>0">{{myinfo.wc}}</span>
        </div>

        <p class="fc-text-center">
          <img class="synthesis_btn" :src="require('../assets/img/' + thisLang + '/btn_Synthesis_2.png')" @click="hecheng" v-if="myinfo.c.njc>0&&myinfo.c.zjc>0&&myinfo.c.bjc>0&&myinfo.c.hjc>0&&myinfo.c.gjc>0&&activeStute==1" />
          <img class="synthesis_btn" :src="require('../assets/img/' + thisLang + '/btn_Synthesis_1.png')" v-else/>
        </p>
      </div>
      <div class="bg_gradient" style="margin-top: 0.4rem">
        <div class="acitve_status statusEnd" v-if="activeStute==2">
          <div class="text">{{$t('m.reward_king')}}:</div>
          <div class="info">
            {{myinfo.wd}} <img src="../assets/img/diamonds.png" class="icon" />
          </div>
          <p class="tip">{{$t('m.reward_tip')}}</p>
        </div>
        <div class="acitve_status" v-else>
          <div class="text">{{$t('m.divide_countdown')}}</div>
          <div class="info">
            <div class="timeItem">
              <span class="day timenum">{{countDownTime.day}}</span>
              <span>D</span>
            </div>
            <div class="vline">:</div>
            <div class="timeItem">
              <span class="hour timenum">{{countDownTime.hour}}</span>
              <span>H</span>
            </div>
            <div class="vline">:</div>
            <div class="timeItem">
              <span class="minute timenum">{{countDownTime.minute}}</span>
              <span>M</span>
            </div>
            <div class="vline">:</div>
            <div class="timeItem">
              <span class="second timenum">{{countDownTime.second}}</span>
              <span>S</span>
            </div>
          </div>
          <p class="tip">{{$t('m.reward_tip')}}</p>
        </div>
      </div>

      <div class="bg_gradient rules_info" style="margin-top: 0.4rem">
        <div class="title">
          <div class="context">
            <div class="text">{{$t('m.event_rule_title')}}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="con">{{$t('m.event_rule_desc')}}</div>
      </div>
    </div>

    <van-popup
      v-model="isShowpopup"
      get-container="#app"
      :close-on-click-overlay="false"
    >
      <div class="choucard">
        <img class="choucard_bg" :src="require('../assets/img/' + thisLang + '/popup.png')" width="100%" />
        <img class="closeBtn" src="../assets/img/btn_closed.png" @click="isShowpopup = false;" />

        <div class="popup_cardinfo" :class="infoClass(winPrizeList)">
          <div class="chou_item" v-for="(item,i) in winPrizeList" :key="'winPrize'+i">
            <img class="popup_cardimg" :src="require('../assets/img/' + thisLang + '/card_'+item.t+'_2.png')" />
            <p>x {{item.c}}</p>
          </div>
        </div>

      </div>
    </van-popup>

      <div class="bigWin" v-show="superPrize">
        <div id="demoCanvas" style="width:100%;height:100%;"></div>
        <img class="gifTitle" :src="require('../assets/img/' + thisLang + '/king_card_title.png')" v-if="gifTitleTitle" />
      </div>
  </div>
</template>

<script>
var _self;
import Vue from "vue";
import { Toast, NoticeBar, Swipe, SwipeItem, Popup } from "vant";
import SVGA from 'svgaplayerweb'
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
//卡类型"t": "，1男爵，2子爵，3伯爵，4侯爵，5公爵",
export default {
  data() {
    return {
      token: "",
      thisLang: localStorage.getItem("localeLang") || "en",
      isShowpopup: false,

      activeStute:1,//0:活动未开启，1:活动中，2:活动已结束
      selCard:0,//1男爵，2子爵，3伯爵，4侯爵，5公爵",
      kingTong:[],
      winPrizeList:[],//中奖信息

      friendSendCard:[],//好友送卡信息
      superPrize:false,
      gifTitleTitle:false,
      countDownTime:{
        day:null,
        hour:null,
        minute:null,
        second:null,
      },
      sendFriendId: null,
      myinfo: {
        ast: "0",
        aet: "0",
        ct: "0",
        td: null,
        cs: { ctp: null, c: 0, s: 0 },
        c: {
          bjc: 0,
          gjc: 0,
          hjc: 0,
          njc: 0,
          zjc: 0
        },
        wc: 0,
        wd: 0,
      },

      requestTime:0,//请求次数

      showDownMask:false,
      parser:null,
      player:null,
    };
  },
  mounted() {
    _self = this;
    _self.token = dsBridge.call("getCurrentUserToken");
    //3feadb40d7454ed4189623cbebfd16fa   helloyou  2120000271
    //8e125d3daeba972f49cf194486857404  哦哈呦 2120000401
    //c476e162d73af843202cca96efc29e6c  21200005058  1774046
    //_self.token = "f38ab8c5488d506f9c4353e1586d2049";
    _self.getMyinfo('first');
      _self.player = new SVGA.Player('#demoCanvas');
      _self.parser = new SVGA.Parser('#demoCanvas');
      _self.player.loops = 1;
      _self.player.clearsAfterStop = true;
      _self.player.fillMode = 'Forward';
      _self.player.setClipsToBounds({clipsToBounds:true});

  },
  filters:{
    rechargeAmount(val){
      if(!val){
        return 0;
      }else{
        var c = (val.toString().indexOf ('.') !== -1) ? val.toLocaleString() : val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        return c;
      }
    },
    friendSendCardInfo(item,te){
      //1男爵，2子爵，3伯爵，4侯爵，5公爵
      switch(item.t){
        case 1:
          return te('m.friend_send_nan',{'msg_ss':item.un});
          break;
        case 2:
          return te('m.friend_send_zi',{'msg_ss':item.un});
          break;
        case 3:
          return te('m.friend_send_bo',{'msg_ss':item.un});
          break;
        case 4:
          return te('m.friend_send_hou',{'msg_ss':item.un});
          break;
        case 5:
          return te('m.friend_send_gong',{'msg_ss':item.un});
          break;
        default:
          return '123'
          break;
      }
    },
  },
  computed:{
    progressNum (n) {
      return function (n) {
          if(n){
            let num = n/500000*100;
            if(num>100){
              num=100;
            }
            return num+ '%'
          }else{
            //return '0'
            return 0
          }

        }
    },
    infoClass(winPrizeList){
      return function(winPrizeList){
        switch(winPrizeList.length){
          case 1:
            return '';
            break;
          case 2:
            return 'info2'
            break;
          case 3:
            return 'info3'
            break;
          case 4:
            return 'info4'
            break;
          case 5:
            return 'info3'
            break;
          default:
            break;
        }
      }

    }
  },
  methods: {
    userIdInput(e){
      //_self.sendFriendId = Number(_self.sendFriendId);
      _self.sendFriendId=_self.sendFriendId.replace(/[^\d]/g, '').replace(/^0{1,}/g,'')
      if(_self.sendFriendId.length>10){
        _self.sendFriendId=_self.sendFriendId.slice(0,10)
      }
    },
    te(arg,t) {
      const hasKey = this.$te(arg,t)
      if (hasKey) {
        const result = this.$t(arg,t)
        return result
      }
      return arg
    },
    //中奖特效
    winprizegif(){
      setTimeout(function(){
        _self.superPrize = true;
      },100);
      setTimeout(function(){
        _self.gifTitleTitle = true;
      },3600)
      setTimeout(function(){
        _self.superPrize = false;
      },14800)

    },
    //获取随机数
    random(min,max){
      return Math.floor(Math.random()*(max-min))+min;
    },
    //生成n个10~99以内数据
    getRandomNum(n){
      for(var i = 1;i<=n;i++){
        let a = _self.random(10,99);
        _self.kingTong.push(a);
      }
    },
    //点击选择卡片
    clickCard(r,t){
      if(!t)return false;
      if(_self.selCard==r){
        _self.selCard = 0;
      }else{
        _self.selCard = r;
      }
    },
    getToken() {
      var requestType = _self.getUrlParam("fromeType");
      if (dsBridge.call("getCurrentUserToken")) {
        requestType = "facecast";
        return dsBridge.call("getCurrentUserToken");
      } else {
        if (_self.getUrlParam("token")) {
          return _self.getUrlParam("token");
        }
      }
    },
    //获取RUL参数值
    getUrlParam(fromeType) {
      var params = decodeURI(window.location.search);
      var reg = new RegExp("(^|&)" + fromeType + "=([^&]*)(&|$)");
      var r = params.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    //获取token信息
    getMyinfo(t) {
      this.$axios({
        method: "get",
        url: "/api/activity/card/myinfo",
        headers: {
          systoken: _self.token||'',
        },
      })
        .then(({ data }) => {
          console.log(data);
          if (data.code == 1) {
            _self.myinfo = data.result;
            _self.friendSendCard=data.result.cgs;
            let st = Number(data.result.ast),et = Number(data.result.aet), ct = Number(data.result.ct);
            if(ct<et){
              if(t){
                _self.countDown(et-ct);
              }
              _self.activeStute=1;
            }else{
              _self.activeStute=2;
            }

            
            if(ct>st){
              _self.getRandomNum(20);
            }



          }else if(data.code==40001){
            Toast(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    countDown(times) {
      times = times / 1000;
      var timer = null;
      timer = setInterval(function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0; //时间默认值
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24));
          hour = Math.floor(times / (60 * 60)) - day * 24;
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60;
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60;
        }
        if (day <= 9) day = "0" + day;
        if (hour <= 9) hour = "0" + hour;
        if (minute <= 9) minute = "0" + minute;
        if (second <= 9) second = "0" + second;
        // $(".day").html(day);
        // $(".hour").html(hour);
        // $(".minute").html(minute);
        // $(".second").html(second);
        _self.countDownTime = {
          day:day,
          hour:hour,
          minute:minute,
          second:second,
        };
        //	console.log(day + "天:" + hour + "小时：" + minute + "分钟：" + second + "秒");
        times--;
        if (times <= 0) {
          setTimeout(function(){
            _self.getMyinfo();
          },500);
          clearInterval(timer);
        }

      }, 1000);
    },

    //  报名
    baoming() {
      if(!_self.token){
        var ua = window.navigator.userAgent.toLowerCase();

		    if (ua.indexOf('micromessenger') > 0 || ua.indexOf('weibo') > 0) {
		        _self.showDownMask=true;
		    } else {
		        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
		            window.location = "FaceShowApp://";
		            window.setTimeout(function() {
		                window.location.href = "http://www.buzzcast.info/";
		            },  2000);
		        } else if (navigator.userAgent.match(/android/i)) {
		           window.location = "myscheme://com.guochao.faceshow"
		            window.setTimeout(function() {
		                window.location = "https://play.google.com/store/apps/details?id=com.guochao.faceshow";
		            },  2000);
		        }else{
		            window.location.href = "https://fsveg.facecast.live/buzzcast.apk";
		        }
		    }
      }else{
         Toast.loading({
          forbidClick: true,
        });
        this.$axios({
          method: "post",
          url: "/tokens/activity/card/signup",
          headers: {
            systoken: _self.token,
          },
        }).then(({ data }) => {
          console.log(data);
          if(data.code==1){
            Toast(_self.$t('m.participated'));
            _self.myinfo.cs.s=1;
          }else if(data.code==110002){
            Toast(_self.$t('m.event_finish'))
          }else if(data.code==110001){
            Toast(_self.$t('m.participated'));
          }else{
            Toast(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
      }

    },
    //抽奖
    choujiang(num) {
      Toast.loading({
        forbidClick: true,
      });
      _self.myinfo.cs.c = _self.myinfo.cs.c-num;
      this.$axios({
        method: "post",
        url: "/tokens/activity/card/draw",
        headers: {
          systoken: _self.token,
        },
        data:{
          c:num
        }
      }).then(({ data }) => {
          console.log(data);
          if(data.code==1){
              _self.getPrizeInfo(data.result.r);
          }else if(data.code==110002){
            Toast(_self.$t('m.event_finish'))
          }else if(data.code==110004){
            Toast(_self.$t('m.not_draws'))
          }else{
            Toast('error');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //查询中奖信息
    getPrizeInfo(r){
       this.$axios({
        method: "get",
        url: "/tokens/activity/card/draw/result/"+r,
        headers:{
          systoken:_self.token
        },
      }).then(({ data }) => {
          console.log(data);
          if(data.code==1){
            _self.isShowpopup = true;
            _self.winPrizeList = data.result.c;
            _self.getMyinfo();
          }else if(data.code==110005){
            if(_self.requestTime>30){
              Toast(_self.$t('m.reward_delay_notice'));
              //_self.getMyinfo();
              _self.requestTime=0;
            }else{
              setTimeout(() => {
                _self.requestTime++;
                _self.getPrizeInfo(r);
              }, 300);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //赠送卡片给好友
    sendCard() {
      Toast.loading({
        forbidClick: true,
      });
      if(!_self.selCard){
        Toast(_self.$t('m.sel_a_card'));
        return;
      }else{
        var thisCardNum=0;
        switch(_self.selCard){
          case 1:
            thisCardNum=_self.myinfo.c.njc;
            break;
          case 2:
            thisCardNum=_self.myinfo.c.zjc;
            break;
          case 3:
            thisCardNum=_self.myinfo.c.bjc;
            break;
          case 4:
            thisCardNum=_self.myinfo.c.hjc;
            break;
          case 5:
            thisCardNum=_self.myinfo.c.gjc;
            break;
          default:
            break;
        }
        if(Number(_self.sendFriendId)>2147483647){
          Toast(_self.$t('m.recipient_not'));
        }else if(thisCardNum>0){
          console.log(_self.sendFriendId);
          this.$axios({
            method: "post",
            url: "/tokens/activity/card/gift",
            headers: {
              systoken: _self.token,
            },
            data:{
              "t": _self.selCard,
              "to": Number(_self.sendFriendId)
            }
          })
          .then(({ data }) => {
            console.log(data);
            if(data.code==1){
              Toast(_self.$t('m.send_success'));
              _self.selCard=0;
              _self.getMyinfo();
            }else if(data.code==110006){
              Toast(_self.$t('m.recipient_not'));
            }else if(data.code==110003){
              Toast(_self.$t('m.card_not_enough'));
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }else{
         // Toast('没有该卡片')

        }
      }

    },
    //合成
    hecheng(){
      Toast.loading({
        forbidClick: true,
      });
      this.$axios({
        method: "post",
        url: "/tokens/activity/card/compound",
        headers: {
          systoken: _self.token,
        }
      })
      .then(({ data }) => {
        console.log(data);
        if(data.code==1){
          Toast.clear();
          //动效结束后刷新数据
          _self.superPrize=true;
          _self.parser.load('./static/img/superWin.svga', function(videoItem) {
              _self.player.setVideoItem(videoItem);
              _self.player.startAnimation();
          })
          _self.player.onFrame(function(e) {
            console.log(e);
            if(e===40){
              _self.gifTitleTitle=true;
               _self.getMyinfo();//动效快结束更新信息
            }else if(e===54){
              _self.gifTitleTitle=false;
            }
          });
          _self.player.onFinished(function() {
            _self.superPrize=false;
          });
        }else{
          Toast(data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },


  },
};
</script>

<style>
#pagecontent {
  background-color: #58007a;
  padding-bottom: 0.4rem;
  position: relative;
  width: 100%;
  height: 100%;
}
/* .notice-swipe {
    height: .8rem;
    line-height: .8rem;
  } */
.bg_gradient {
  background-image: linear-gradient(#8d008f, #5200b5);
  border-radius: 0.1rem;
}
.bg_gradient2 {
  background-image: linear-gradient(180deg, #8d008f, #5200b5);
  border-radius: 0.1rem;
}
.banner1 {
  width: 100%;
}
.content {
  padding: 0 0.1rem;
}
.baomingbtn {
  position: absolute;
  left: 0;
  right: 0;
  top: 3.46rem;
  text-align: center;
}
.baomingbtn img {
  height: 0.81rem;
  margin: auto;
}
.progressbox {
  padding: 0.28rem;
  margin: 0.4rem 0 0;
}
.progressbox_title {
  text-align: center;
  color: #fff;
  font-size: 0.28rem;
  padding-bottom: 0.2rem;
}
.progressbarbox {
  position: relative;
  display: flex;
}
.progressbar {
  position: relative;
  width: 6.43rem;
  height: 0.8rem;

  /* left: .15rem; */
  padding: 0 0.2rem;
  background-image: url("../assets/img/progres_bar.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-bottom: 0.1rem;
  margin: 0 0.1rem;
}
.progressbar .jindu {
  position: absolute;
  width: 30%;
  margin-left: -15%;
  left: 50%;
  /* background-color: rgba(0,0,0,.5); */
  top: -0.04rem;
  text-align: center;
  color: #02c7fe;
}
.progressbar .dot {
  width: 0.42rem;
  height: 0.42rem;
  margin-bottom: 0.05rem;
}
.startnum,
.endnum {
  color: #ff39c0;
  margin-top: 0.02rem;
}
.color_yellow {
  color: #fff000;
}
.drawInfo {
  padding: 0.2rem 0;
}
.drawInfo_text {
  color: #fff;
  text-align: center;
}
.choubtn {
  width: 2.36rem;
  height: 0.66rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}
.myCard {
  padding: 0.4rem .3rem;
}
.card_group {
  margin-top: 0.3rem;
}
.cardbox {
  padding: 0.04rem;
  border-radius: 0.12rem;
  /* border: rgba() solid #fff000; */
  margin: 0 0.04rem;
  position: relative;
}
.cardbox.on {
  background-image: url(../assets/img/bg_Select.png);
  background-size: 100% 100%;
}
.cardimg {
  width: 1.2rem;
  height: 1.77rem;
}
.flag {
  background-color: #e40040;
  min-width: 1.5em;
  line-height: 1.2;
  border-radius: 1em;
  position: absolute;
  right: -0.24em;
  top: -0.3em;
  color: #fff000;
  font-size: 0.2rem;
  text-align: center;
  padding: 0 0.05rem;
}
.giftid_input {
  width: 5.53rem;
  height: 0.64rem;
  background: url(../assets/img/giftinput.png) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  margin: 0.3rem 0 0 0.48rem;
}
.giftid_input .inputbox{
  flex: 1;
  height: 0.64rem;
  overflow: hidden;
}
.giftid_input input {
  width: 104%;
  height: 0.64rem;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0 0 0 4%;
  color: #fff;
  font-size: .28rem;
}
input::-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.giftid_input img {
  width:1.32rem;
  height: 0.62rem;
}

.hecheng {
  width: 7.3rem;
  height: 6.7rem;
  margin-top: 0.4rem;
  background: url(../assets/img/bg_Synthesis.png) no-repeat;
  background-size: 100% 100%;
  padding: 0.3rem .95rem;
  box-sizing: border-box;
}
.hc_notice {
  width: 5.4rem;
  height: 0.46rem !important;
  line-height: 0.46rem !important;
  border-radius: 0.4rem;
  font-size: .28rem;
  box-sizing: border-box;
}
.notice-swipe {
  width: 100%;
  height: 0.46rem;
}
.hc_notice .van-notice-bar__content {
  width: 100%;
  text-align: center;
}
.notice-swipe .itembar {
  font-size: 0.24rem;
}
.cardbox_big {
  width: 2.86rem;
  height: 4.11rem;
  position: relative;
  left: 50%;
  margin-left: -1.43rem;
  margin-top: 0.4rem;
}
.cardbox_big .cardimg {
  width: 100%;
  height: 100%;
}
.cardbox_big .flag {
  font-size: 0.3rem;
  min-width: 0.82rem;
  line-height: 0.46rem;
  text-align: center;
  box-sizing: border-box;
}
.synthesis_btn {
  width: 2rem;
  margin-top: 0.3rem;
}
.acitve_status {
  color: #fff;
}
.acitve_status.statusEnd {
  background: url(../assets/img/acitve_status_bg.png) no-repeat;
  background-size: 100% auto;
}
.acitve_status .text {
  padding: 0.48rem 0.36rem;
  text-align: center;
  font-size: 0.34rem;
}
.acitve_status .info {
  width: 5.08rem;
  height: 0.72rem;
  margin: auto;
  background: url(../assets/img/countdown.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.acitve_status .info .icon {
  width: 0.5rem;
  margin-left: 0.1rem;
}
.acitve_status .tip {
  font-size: 0.3rem;
  color: #fff;
  opacity: 0.8;
  padding: 0.48rem 0.6rem;
  text-align: center;
}

.timeItem {
  font-size: 0.24rem;
}
.timenum {
  font-size: 0.4rem;
  width: 1.2rem;
}
.vline {
  margin: 0 0.1rem;
}
.rules_info {
  margin-top: 0.4rem;
  padding: 0 0.7rem;
  color: #fff;
  font-size: 0.34rem;
}
.rules_info .title {
  padding-top: 0.4rem;
  text-align: center;
}
.rules_info .context {
  display: inline-block;
}
.rules_info .context .text {
  font-weight: bold;
  line-height: 1;
  padding: 0 0.2rem;
}
.rules_info .context .line {
  height: 0.22rem;
  background-color: #5c00c5;
  margin-top: -0.14rem;
}
.rules_info .con {
  line-height: 1.8;
  padding: 0.4rem 0;
}
.van-popup {
  background-color: transparent !important;
}
.choucard {
  width: 5.1rem;
  height: 6.8rem;
  position: relative;
  padding: 0.5rem;
}
.choucard_bg {
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  width: 5.1rem;
}
.closeBtn {
  width: 0.88rem;
  height: 0.88rem;
  position: absolute;
  right: 0.06rem;
  top: 0.06rem;
  z-index:9;
}

.popup_cardinfo {
  /* width: 100%; */
  height: 5.3rem;
  position: relative;
  text-align: center;
  padding-top: 1.4rem;
  color: #fff;
  font-size: 0.4rem;
  display: flex;
  align-content: space-evenly;
  justify-content: center;
  flex-wrap: wrap;
}
.chou_item img {
  width: 2.4rem;
  height: 3.54rem;
  margin-bottom: 0.2rem;
}
.popup_cardinfo.info2,.popup_cardinfo.info3,.popup_cardinfo.info4{
  font-size: 0.36rem;
}
.popup_cardinfo.info2 .chou_item img{
  width: 1.68rem;
  height: 2.48rem;
  padding: 0 0.2rem;
}
.popup_cardinfo.info3 .chou_item img{
  width: 1.2rem;
  height: 1.77rem;
  margin-bottom: 0.1rem;
  padding: 0 0.15rem;
}
.popup_cardinfo.info4{
  padding-left: .2rem;
  padding-right: .2rem;
  /* box-sizing: border-box; */
}
.popup_cardinfo.info4 .chou_item img{
  width: 1.2rem;
  height: 1.77rem;
  margin-bottom: 0.1rem;
  padding: 0 0.2rem;
}

.van-overlay {
  background-color: rgba(0, 0, 0, 0.6);
}
.bigWin{
  width: 100vw;
  max-width: 540px;
  height: 100vh;
  position: fixed;
  z-index: 1;
  top: 0;
  background-color: rgba(0,0,0,.7);
}
.gifImg{
  width: 100%;
  height: 100%;
}
.gifTitle{
  height: .26rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 3.5rem;
}
.sendCardAd{
  position: absolute;
  height: .6rem;
  line-height: .6rem;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.sendCardAd .van-icon__image{
  width: .4rem;
  height: .38rem;
}
.sendCardswiper{
  height: .6rem;
  line-height: .6rem;
  font-size: .3rem;
  padding:0 .2rem
}
.activeTime{
  position: absolute;
  width: 5.52rem;
  left:.99rem;
  top: 4.56rem;
}

/*---------下载APP提示遮罩层---------*/
#down_mask {
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 100%;
  max-width: 540px;
  background-color: rgba(0, 0, 0, 0.8);
}
#down_mask > img {
  width: auto;
  height: 2rem;
  position: absolute;
  right: 0;
  top: 0;
}
#down_mask p {
  color: #fff;
  position: absolute;
  top: 1.8rem;
  left: 30%;
  font-size: 0.32rem;
}
#down_mask p img {
  width: 0.8rem;
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
}


.animateClass{
  animation:mymove 5s infinite;
  -webkit-animation:mymove 3s infinite; /*Safari and Chrome*/
  animation-direction:alternate;/*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation:mymove 3s infinite;
  -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
@keyframes mymove
{
0%{
transform: scale(1);  /*开始为原始大小*/
}
25%{
  transform: scale(1.1); /*放大1.1倍*/
}
50%{
  transform: scale(1);
}
75%{
  transform: scale(1.1);
}

}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue